import axios from "axios";

const queryCors = "https://smartroam-be.mobiliseconnect.com:7460/crm";

export const ApiPost = (url, parameters) =>
  axios.post(queryCors + url, parameters, {
    headers: {
      apikey: "FbXe8VP3wAeuJgmGIH9mv8RcD7uzV6OrisP3XwCyYsEJKwb2cs",
      companycode: "Web",
    },
  });

export const ApiPostEmail = (url, parameters) =>
  axios.post("https://smartroam-be.mobiliseconnect.com:7460" + url, parameters, {
    headers: {
      apikey: "FbXe8VP3wAeuJgmGIH9mv8RcD7uzV6OrisP3XwCyYsEJKwb2cs",
      companycode: "Web",
    },
  });

export const ApiPostAuth = (url, parameters) =>
  axios.post(queryCors + url, parameters, {
    headers: {
      apikey: "FbXe8VP3wAeuJgmGIH9mv8RcD7uzV6OrisP3XwCyYsEJKwb2cs",
      companycode: "Web",
      Authorization: `Bearer ${
        localStorage.getItem("auth") || Math.random().toFixed(21).substring(2)
      }`,
    },
  });

export const ApiGet = (url) =>
  axios.get(queryCors + url, {
    headers: {
      apikey: "FbXe8VP3wAeuJgmGIH9mv8RcD7uzV6OrisP3XwCyYsEJKwb2cs",
      companycode: "Web",
      Authorization: `Bearer ${
        localStorage.getItem("auth") || Math.random().toFixed(21).substring(2)
      }`,
    },
  });

export const ApiDelete = (url, parameters) =>
  axios.delete(queryCors + url, {
    headers: {
      apikey: "FbXe8VP3wAeuJgmGIH9mv8RcD7uzV6OrisP3XwCyYsEJKwb2cs",
      companycode: "Web",
      Authorization: `Bearer ${
        localStorage.getItem("auth") || Math.random().toFixed(21).substring(2)
      }`,
    },
    data: parameters,
  });